export default "__VITE_ASSET__B7YV_41I__"